var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar", staticStyle: { overflow: "initial" } },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _vm._v(" "),
      _c("breadcrumb", { staticClass: "breadcrumb-container" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _c(
            "span",
            { staticClass: "hidden-sm-and-down" },
            [
              _c("span", { staticClass: "dnone" }, [
                _vm._v(_vm._s(_vm.agentInfo.id)),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    plain: "",
                    size: "mini",
                    icon: "el-icon-male",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({ path: "/home/article?type=3" })
                    },
                  },
                },
                [_vm._v("学习教程")]
              ),
              _vm._v(" "),
              _vm.updateWxxcx && _vm.siteInfo.wx_third_api_switch
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        plain: "",
                        size: "mini",
                        icon: "el-icon-warning",
                      },
                      on: {
                        click: function ($event) {
                          _vm.updateWxxcx = false
                          _vm.$router.push({ path: "/setting/index" })
                        },
                      },
                    },
                    [_vm._v("微信小程序待更新")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.updateAlixcx && _vm.siteInfo.zfb_third_api_switch
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        plain: "",
                        size: "mini",
                        icon: "el-icon-warning",
                      },
                      on: {
                        click: function ($event) {
                          _vm.updateAlixcx = false
                          _vm.$router.push({ path: "/setting/aliIndex" })
                        },
                      },
                    },
                    [_vm._v("支付宝小程序待更新")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.checkRoles(["terminal"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        plain: "",
                        size: "mini",
                        icon: "el-icon-question",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ path: "/home/feedback" })
                        },
                      },
                    },
                    [_vm._v("提交工单")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.token1
            ? _c(
                "el-button",
                {
                  staticClass: "mr-10",
                  attrs: { plain: "", size: "mini", icon: "el-icon-back" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.toAdmin()
                    },
                  },
                },
                [_vm._v("\n      返回总后台\n    ")]
              )
            : _c(
                "el-button",
                {
                  staticClass: "mr-10",
                  attrs: {
                    plain: "",
                    size: "mini",
                    icon: "el-icon-switch-button",
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.logout($event)
                    },
                  },
                },
                [_vm._v("\n      退出登录\n    ")]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }